const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  prev: {
    de: 'Zurück blättern',
    en: 'move backwards',
  },
  next: {
    de: 'Weiter blättern',
    en: 'move forwards',
  },
  page: {
    de: 'Seite',
    en: 'Page',
  },
};

export const glideControls = `
    <div class="glide__controls" data-glide-el="controls">
        <button
          class="arrow arrow-left"
          aria-label="${labels.prev[lang]}"
          data-glide-dir="<"
          >
          <span class="is-hidden">${labels.prev[lang]}</span>
          <span class="icon-arrow-left" aria-hidden="true"></span>
        </button>
        <button
          class="arrow arrow-right"
          aria-label="${labels.next[lang]}"
          data-glide-dir=">"
          >
          <span class="glide__control-text">${labels.next[lang]}</span>
          <span class="icon-arrow-right" aria-hidden="true"></span>
        </button>
    </div>
`;

export const generateBullets = items => `
    <div class="glide__bullets" data-glide-el="controls[nav]">
    ${items
      .map(
        (item, index) =>
          `<button aria-label="${labels.page[lang]} ${index}" class="glide__bullet" data-glide-dir="=${index}"><span class="is-hidden">${labels.page[lang]} ${index}</span></button>`
      )
      .join('')}
    </div>
`;

export const generateNumeric = slidesLength => `
    <div class="glide__numeric">
        <p class="glude__numeric-text"> <span class="glude__numeric-index">1</span>/${slidesLength}</p>
    </div>
`;
